import styled from 'styled-components';

const InputStyle = styled.div`
	.input_cont {
		--smileSize: 30px;

		position: relative;

		.smile {
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			height: var(--smileSize);
			margin: auto;
			fill: var(--color2);
		}

		input {
			background-color: var(--color1);
		}

		~ div {
			position: relative;
		}

		/* Change autocomplete styles in WebKit */
		input:-webkit-autofill,
		input:-webkit-autofill:hover,
		input:-webkit-autofill:focus,
		textarea:-webkit-autofill,
		textarea:-webkit-autofill:hover,
		textarea:-webkit-autofill:focus,
		select:-webkit-autofill,
		select:-webkit-autofill:hover,
		select:-webkit-autofill:focus {
			border: 1px solid var(var(--autoSelectBg));
			-webkit-text-fill-color: var(--autoSelectColor);
			color: var(--autoSelectColor);
			background-color: var(--autoSelectBg);
			-webkit-box-shadow: 0 0 0px 1000px var(--autoSelectBg) inset;
			transition: background-color 5000s ease-in-out 0s;
		}

		/* Chrome, Safari, Edge, Opera */
		input::-webkit-outer-spin-button,
		input::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}

		/* Firefox */
		input[type='number'] {
			-moz-appearance: textfield;
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			--smileSize: 32px;
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			--smileSize: 40px;
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			--smileSize: 50px;
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
			--smileSize: 56px;
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
			--smileSize: 61px;
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			--smileSize: 80px;
		}
	}
`;

export default InputStyle;
